import { useContext } from 'react';

import { MobileSizeContext } from '../../../helpers/MobileSizeContext';

export const useFilterColumnCount = () => {
  const { isTablet, isMobile } = useContext(MobileSizeContext);
  if (isMobile) return 1;
  if (isTablet) return 2;

  // desktop
  return 5;
};
